import { gql } from "@apollo/client";

export const getLTIIntegrationsCredsQuery = gql`
  query getLTIIntegrationsCreds($input: LTIIntegrationsCredsQueryInput!) {
    integration {
      getLTIIntegrationsCredsV2(input: $input) {
        metadata
        integrationCreds {
          id
          parentId
          entityType
          entityId
          deploymentId
          serviceName
          name
          url
          clientId
          clientSecret
          version
          messageType
          credType
          isToolEnabled
          metadata
          toddleCreds
          apiToken
        }
      }
    }
  }
`;
